import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    close: 'absolute top-3 right-3 z-70 cursor-pointer lg:top-6 lg:right-6 lg:flex'
  },
  variants: {
    type: {
      shops: {},
      pickup: {
        close: 'hidden'
      }
    }
  },
  defaultVariants: {}
});
